import React from "react"

import { Input } from "antd"
import cls from "classname"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import { useIncognito } from "../../hooks/useIncognito"

import "./styles.less"

export const InputComponent = React.forwardRef(
  ({ placeholder, onChange, className, sensitive, type, ...props }, ref) => {
    const isDisabledTransition = useSelector((state) => state.nav.disabledTransition)
    // Opt-in companion to Table's `sensitive` column flag: masks the value AND whatever is
    // typed while Incognito is on, instead of every call site computing
    // `type={incognito ? "password" : "text"}` by hand.
    const incognito = useIncognito()

    return (
      <Input
        placeholder={placeholder}
        onChange={onChange}
        type={sensitive && incognito ? "password" : type}
        className={cls(className, "input", {
          "disabled-transition": isDisabledTransition
        })}
        ref={ref || null}
        {...props}
      />
    )
  }
)

InputComponent.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  sensitive: PropTypes.bool
}

export default InputComponent
